/**
 * @file: 查询鼠标箭头指向的商品
 * @author: xiaolong.huang@dmall.com
 */

import * as Toolkit from '../../../toolkit/index';
import * as CubeTree from '../../../cubeTree/index';
import CodiSystem from '../../../codiSystem/index';
import Utils from '../../../utils/util';
import { layoutSplitY } from './layoutSplitY';

function findTargetCabinetChild(params: FindTargetCabinetChildParams): CabinetCubeInsertInfo {
    for(let i = 0; i < params.colPaintCoordinates.length; i++) {
        let coordinate: PaintCoordinate = params.colPaintCoordinates[i].colCoordinate;
        let colCubes: CubeId[] = params.colPaintCoordinates[i].cubeIds;
        let theLastCube: CubeId = colCubes[colCubes.length - 1];
        let point: MousePoint = {
            ...params.mousePoint
        };
        let rect: Rect = {
            left: coordinate.left,
            top: coordinate.top,
            width: coordinate.width,
            height: coordinate.height
        };
        let pointInCol: boolean = Toolkit.pointInRect(point, rect);

        if (colIsAllInDrag(params.dragCubes, colCubes) && pointInCol) {
            return {
                target: null,
                direction: ''
            };
        }

        if (!pointInCol) {
            continue;
        }

        let dir: string = Toolkit.pointOfRectDirection(point, rect, 0.5);

        if (dir !== 'middle') {
            // 插入新列
            return insertToNewColInfo(params.colPaintCoordinates[i], dir);
        }

        // 列内插入
        return insertToColInfo(params.colPaintCoordinates[i], params.mousePoint, params.dragCubes);
    }

    return {
        target: CubeTree.findFreezersCabinet(params.targetFreezer),
        direction: ''
    };
}

// 新增列
function insertToNewColInfo(colCoordinateInfo: ColCubePaintCoordinate, dir: string): CabinetCubeInsertInfo {
    let halfHeight: LogicsicsMeasurement = Utils.math(colCoordinateInfo.colCubesTotalHeight, 2, '/');
    let bottomLine: LogicsicsMeasurement = Utils.math(colCoordinateInfo.colCoordinate.top, colCoordinateInfo.colCoordinate.height, '+');
    let result = {
        target: '',
        direction: dir,
        arrowPosition: {
            left: 0,
            top: Utils.math(bottomLine, halfHeight, '-')
        }
    };

    if (dir === 'left') {
        result.target = colCoordinateInfo.cubeIds[0];
        result.arrowPosition.left = colCoordinateInfo.colCoordinate.left;
    }
    else {
        result.target = colCoordinateInfo.cubeIds[colCoordinateInfo.cubeIds.length - 1];
        result.arrowPosition.left = Utils.math(colCoordinateInfo.colCoordinate.left, colCoordinateInfo.colCoordinate.width, '+');
    }

    return result;
}

// 往列中插入
function insertToColInfo(colCoordinateInfo: ColCubePaintCoordinate, mousePoint: MousePoint, dragCubes: CubeId[]): CabinetCubeInsertInfo {
    let halfWidth: LogicsicsMeasurement = Utils.math(colCoordinateInfo.colCoordinate.width, 2, '/');
    let colCubeIds: CubeId[] = colCoordinateInfo.cubeIds;
    let result = {
        target: null,
        direction: '',
        arrowPosition: {
            left: Utils.math(colCoordinateInfo.colCoordinate.left, halfWidth, '+'),
            top: 0
        }
    };
    let point: MousePoint = {
        ...mousePoint
    };
    let targets: CubeId[] = Utils.listDeleteItems(colCubeIds, dragCubes);
    let targetsCubePaintCoordinate: CubePaintCoordinate[] = CodiSystem.getPaintCoordinates(targets);
    let layoutArea: CabinetColPaintCoordinateItem[] = layoutSplitY(targetsCubePaintCoordinate, {
        width: colCoordinateInfo.colCoordinate.width,
        height: colCoordinateInfo.colCoordinate.height,
        left: colCoordinateInfo.colCoordinate.left,
        top: colCoordinateInfo.colCoordinate.top
    });
    let arrowTo: CabinetColPaintCoordinateItem|null = null;

    for(let i = 0; i < layoutArea.length; i++) {
        let coordinate: CabinetColPaintCoordinateItem = layoutArea[i];
        let rect: Rect = {
            left: coordinate.left,
            top: coordinate.top,
            width: coordinate.width,
            height: coordinate.height
        };

        if (Toolkit.pointInRect(point, rect)) {
            arrowTo = coordinate;
            break;
        }
    }

    if (!arrowTo) {
        return result;
    }

    let targetPaintCoordinate: PaintCoordinate = CodiSystem.getPaintCoordinate(arrowTo.id);

    result.target = arrowTo.id;
    result.direction = arrowTo.dir;

    if (result.direction === 'top') {
        result.arrowPosition.top = targetPaintCoordinate.top;
    }
    else {
        result.arrowPosition.top = Utils.math(targetPaintCoordinate.top, targetPaintCoordinate.height, '+');
    }

    return result;
}

// 是否整列都被拖拽
function colIsAllInDrag(dragCubes: CubeId[], colCubes: CubeId[]): boolean {
    let dragCubesList: Set<CubeId> = new Set(dragCubes);

    return colCubes.every((cube: CubeId): boolean => {
        return dragCubesList.has(cube);
    });
}

export {
    findTargetCabinetChild
};
